export default "__VITE_ASSET__MLvexESf__"